/*
 * Shared landing page buy module (lp-buy-module): reports product card and
 * "Shop all" clicks to window.dataLayer. Standalone so the module works on
 * any landing page template. Delegated, so theme editor reloads need no
 * re-setup.
 */
(() => {
  if (window.lpBuyModule) return;
  window.lpBuyModule = { version: 1 };

  function track(event, data = {}) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...data });
  }

  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element ? event.target.closest('a') : null;
    if (!link) return;
    const card = link.closest('[data-lpb-card]');
    if (card) track('lpb_card_click', { lpb_product: card.dataset.lpbCard });
    else if (link.hasAttribute('data-lpb-shop-all')) track('lpb_shop_all');
  });
})();
